export interface TransactionFilterOption {
  label: string;
  value: string;
}

export function filterTransactionEventOptions(
  options: TransactionFilterOption[],
  searchText: string
): TransactionFilterOption[] {
  const normalizedSearch = searchText.trim().toLowerCase();

  if (!normalizedSearch) {
    return options;
  }

  return options.filter(option =>
    option.label.toLowerCase().includes(normalizedSearch)
  );
}

export function formatDateForSearch(date: Date | null): string {
  if (!date) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
